__turbopack_context__.v({
  "caret": "vfJa-a_caret",
  "headline": "vfJa-a_headline",
  "line": "vfJa-a_line",
  "out": "vfJa-a_out",
  "page": "vfJa-a_page",
  "say": "vfJa-a_say",
  "stage": "vfJa-a_stage",
  "warn": "vfJa-a_warn",
});
